module.exports = __webpack_public_path__ + "img/reign-of-serenity-2.d2ac06ff.webp";